import Logo from './logo.js';
import LogoShort from './logo-short.js';
import LogoSingleColor from './logo-single-color.js';
import '../styles.js';
import AppLogo from './app-logo.js';

const LOGO_MOBILE_WIDTH = 128;

export default {
	Logo,
	LogoShort,
	LogoMobile: Logo, // removed logo-mobile.js as we are using file from CloudFront
	LOGO_MOBILE_WIDTH,
	AppLogo,
	LogoSingleColor
};
